import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useCookieConsent } from '@/context/CookieConsentContext';
import { CookiePreferencesModal } from '@/components/CookiePreferencesModal';

export function CookieConsentBanner(): JSX.Element | null {
  const { isBannerVisible, acceptAll, rejectNonEssential, openPreferences } = useCookieConsent();

  useEffect(() => {
    const className = 'has-cookie-consent-banner';
    if (isBannerVisible) {
      document.body.classList.add(className);
      return () => document.body.classList.remove(className);
    }
    document.body.classList.remove(className);
    return undefined;
  }, [isBannerVisible]);

  if (!isBannerVisible) return <CookiePreferencesModal />;

  return (
    <>
      <section
        role="region"
        aria-label="Cookie consent"
        className="fixed inset-x-0 bottom-0 z-[50] border-t border-gray-200 bg-white/95 shadow-2xl backdrop-blur"
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-3 px-4 py-4 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
          <p className="text-sm text-gray-700">
            We use necessary cookies to run GSGO.org and optional analytics cookies (Google
            Analytics, Google Tag Manager, Microsoft Clarity). Under GDPR and RA 10173, you can
            choose your preference. Read our{' '}
            <Link to="/privacy-policy" className="font-semibold text-[#1e3a5f] underline underline-offset-2">
              Privacy Policy
            </Link>
            .
          </p>
          <div className="flex flex-wrap items-center gap-2 sm:justify-end">
            <button
              type="button"
              onClick={rejectNonEssential}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 transition-colors hover:bg-gray-100"
            >
              Necessary Only
            </button>
            <button
              type="button"
              onClick={openPreferences}
              className="rounded-lg border border-[#1e3a5f] px-4 py-2 text-sm font-semibold text-[#1e3a5f] transition-colors hover:bg-[#f1f5fb]"
            >
              Manage Preferences
            </button>
            <button
              type="button"
              onClick={acceptAll}
              className="rounded-lg bg-[#1e3a5f] px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-[#152a45]"
            >
              Accept All
            </button>
          </div>
        </div>
      </section>
      <CookiePreferencesModal />
    </>
  );
}
